import * as angular from 'angular';

const seiteIcon = require('../../images/icons/seite.svg');
const feldgruppeIcon = require('../../images/icons/feldgruppe.svg');
const tabelleIcon = require('../../images/icons/tabelle.svg');
const akkordeonIcon = require('../../images/icons/akkordeon.svg');
const medienAkkordeonIcon = require('../../images/icons/medienakkordeon.svg');

('use strict');

/* globals alert, confirm */
/**
 * @ngdoc function
 * @name formDesignerApp.controller:MainCtrl
 * @description
 * # MainCtrl
 * Controller of the formApp
 */

angular
  .module('formApp')
  .controller('MainCtrl', [
    '$scope',
    '$routeParams',
    '$location',
    'CONFIG',
    'mappings',
    'navigationGuard',
    'resizeGuard',
    'engineVersionHandler',
    '$timeout',
    '$templateCache',
    '$compile',
    'formHandler',
    'fieldGroupService',
    'elementHelper',
    function (
      $scope,
      $routeParams,
      $location,
      CONFIG,
      mappings,
      navigationGuard,
      resizeGuard,
      engineVersionHandler,
      $timeout,
      $templateCache,
      $compile,
      formHandler,
      fieldGroupService,
      elementHelper
    ) {
      $scope.CONFIG = CONFIG;
      $scope.console = console;
      $scope.mappings = mappings;

      // Check whether we are running in local mode
      var regex = new RegExp('[\\?&]mandant=([^&#]*)');
      var matches = regex.exec(location.search);
      var mandant = matches === null ? '' : decodeURIComponent(matches[1].replace(/\+/g, ' '));
      $scope.isLocal = mandant === 'local';
      $scope.isWeb = CONFIG.ENABLE_WEB_MODE && $location.path() === '/web';

      $scope.helpers = {
        element: elementHelper
      };

      $scope.impressumUrl = CONFIG.IMPRESSUM_URL;
      $scope.datenschutzUrl = CONFIG.DATENSCHUTZ_URL;

      $scope.viewOptions = {
        compactMode: false,
        hideRows: false,
        hideGroups: false
      };

      if ($scope.isLocal) {
        $scope.returnUrl = CONFIG.LOCAL_RETURN_URL.replace('{port}', $routeParams.nodeId);
      } else {
        $scope.returnUrl = CONFIG.RETURN_URL.replace(':formId', $routeParams.nodeId);
      }

      $scope.models = {
        selected: null,
        editing: null,
        editingOriginal: null,
        form: null,
        ownFieldGroups: [],
        fimFieldGroups: [],
        fieldTemplates: [
          {
            id: '',
            label: '',
            type: 'STRING',
            width: 12,
            validationRules: []
          },
          {
            id: '',
            label: '',
            type: 'TEXTAREA',
            width: 12,
            validationRules: []
          },
          {
            id: '',
            label: '',
            type: 'STRING_AJAX_AUTOCOMPLETE',
            width: 12,
            validationRules: [],
            externalDataSourceProperties: {
              url: '',
              scope: 'EMPTY',
              fieldIds: [],
              headers: {}
            },
            additionalConfig: {
              '@type': 'AdditionalStringAjaxAutocompleteConfig',
              autocompleteMinCharCount: '1'
            }
          },
          {
            id: '',
            label: '',
            type: 'SINGLE_CHECKBOX',
            value: false,
            width: 12,
            validationRules: []
          },
          {
            id: '',
            label: '',
            type: 'CHECKBOX',
            layout: '',
            possibleValues: [
              {
                label: '',
                value: ''
              }
            ],
            value: [],
            width: 12,
            validationRules: []
          },
          {
            id: '',
            label: '',
            type: 'RADIO_BUTTONS',
            layout: '',
            possibleValues: [],
            value: '',
            width: 12,
            validationRules: []
          },
          {
            id: '',
            label: '',
            type: 'BOOLEAN',
            layout: '',
            value: null,
            width: 12,
            validationRules: []
          },
          {
            id: '',
            label: '',
            type: 'DROPDOWN_SINGLE_SELECT',
            possibleValues: [],
            value: '',
            width: 12,
            validationRules: []
          },
          {
            id: '',
            label: '',
            type: 'DROPDOWN_SINGLE_SELECT_AJAX',
            possibleValues: [],
            width: 12,
            validationRules: [],
            externalDataSourceProperties: {
              url: '',
              scope: 'EMPTY',
              fieldIds: [],
              headers: {}
            }
          },
          {
            id: '',
            label: '',
            type: 'DATE',
            value: null,
            width: 12,
            validationRules: []
          },
          {
            id: '',
            label: '',
            type: 'TIME',
            value: null,
            width: 12,
            validationRules: []
          },
          {
            id: '',
            label: '',
            type: 'EURO_BETRAG',
            width: 12,
            validationRules: []
          },
          {
            id: '',
            label: '',
            type: 'MULTIPLE_FILE',
            width: 12,
            validationRules: [],
            additionalConfig: {
              '@type': 'AdditionalFileConfig',
              compress: true
            }
          },
          {
            id: '',
            type: 'DOWNLOAD',
            value: 'Herunterladen',
            width: 12,
            externalDataSourceProperties: {
              url: '',
              scope: 'EMPTY',
              fieldIds: [],
              headers: {}
            }
          },
          {
            id: '',
            type: 'KFZ_KENNZEICHEN',
            width: 12,
            additionalConfig: {
              '@type': 'AdditionalKfzKennzeichenConfig',
              kennzeichenType: 'CAR'
            }
          },
          {
            id: '',
            label: '',
            type: 'H1',
            width: 12,
            validationRules: []
          },
          {
            id: '',
            label: '',
            type: 'H2',
            width: 12,
            validationRules: []
          },
          {
            id: '',
            label: '',
            type: 'TEXT',
            width: 12,
            validationRules: []
          },
          {
            id: '',
            type: 'PLACEHOLDER',
            width: 12
          },
          {
            id: '',
            label: '',
            type: 'HINTBOX',
            width: 12,
            additionalConfig: {
              '@type': 'AdditionalHintboxConfig',
              text: '',
              status: ''
            }
          },
          {
            id: '',
            type: 'VIDEO',
            width: 12,
            additionalConfig: {
              '@type': 'AdditionalVideoConfig',
              url: '',
              subtitleUrl: ''
            }
          },
          {
            id: '',
            type: 'IMAGE',
            width: 12,
            additionalConfig: {
              '@type': 'AdditionalImageConfig',
              url: '',
              alt: ''
            }
          }
        ],

        fieldContainerTemplates: [
          {
            title: 'Abschnitt',
            icon: seiteIcon,
            dndType: 'Section',
            item: {
              title: '',
              fieldGroups: []
            }
          },
          {
            title: 'Gruppe',
            icon: feldgruppeIcon,
            dndType: 'Group',
            item: {
              title: '',
              rows: []
            }
          },
          {
            title: 'Tabelle',
            icon: tabelleIcon,
            dndType: 'Group',
            item: {
              title: '',
              multiple: true,
              layout: 'TABLE',
              rows: []
            }
          },
          {
            title: 'Akkordeon',
            icon: akkordeonIcon,
            dndType: 'Group',
            item: {
              title: '',
              multiple: true,
              layout: 'ACCORDION',
              rows: []
            }
          },
          {
            title: 'Medien-Akkordeon',
            icon: medienAkkordeonIcon,
            dndType: 'MediaAccordion',
            item: {
              '@type': 'MediaAccordion',
              elements: []
            }
          },
          {
            title: 'Medien-Akkordeon-element',
            icon: medienAkkordeonIcon,
            dndType: 'MediaAccordionElement',
            item: {
              title: '',
              fields: []
            }
          }
        ]
      };

      $scope.fieldgroupsColl = [];
      $scope.duplicateId = null;
      $scope.duplicateType = null;

      $scope.init = function () {
        $scope.derivative = CONFIG.DERIVATIVE;

        // Load form method of formHandler factory, execute right away
        formHandler.loadForm($scope);

        $scope.loadFieldGroups();

        if (!CONFIG.DEBUG) {
          navigationGuard.registerGuardian($scope.formChangedGuardian);
        }

        $scope.$on('edit-close', function () {
          $scope.models.editing = null;
        });

        $scope.$on('preview-close', function () {
          $scope.models.preview = null;
        });

        $scope.$watch('models.form.engineVersion', function (newEngineVersion, oldEngineVersion) {
          if (!newEngineVersion || !oldEngineVersion || newEngineVersion === oldEngineVersion) {
            return;
          }

          engineVersionHandler.migrateEngineVersion($scope.models.form, newEngineVersion);
        });
      };

      const eventListener = function (event) {
        if (event.origin !== window.location.origin) {
          return;
        }
        if (event.data === 'ready') {
          (document.getElementById('fd-m-preview-frame') as any).contentWindow.postMessage(
            JSON.parse(angular.toJson($scope.models.form)),
            window.location.origin
          );
        }
      };

      $scope.showPreview = function () {
        $scope.models.preview = {
          form: angular.copy($scope.models.form)
        };

        window.removeEventListener('message', eventListener);
        window.addEventListener('message', eventListener);
      };

      $scope.formLoaded = function () {
        return $scope.models.form !== null;
      };

      $scope.isGroupAddable = function () {
        return $scope.sectionExists() && !$scope.viewOptions.hideGroups;
      };

      $scope.isFieldAddable = function () {
        return $scope.groupExists() && !($scope.viewOptions.hideGroups || $scope.viewOptions.hideRows);
      };

      $scope.groupExists = function () {
        var groupExists = false;
        if (!$scope.models.form || !$scope.models.form.sections) {
          return false;
        }
        angular.forEach($scope.models.form.sections, function (section) {
          if (section.fieldGroups.length !== 0) {
            groupExists = true;
            return false;
          }
        });
        return groupExists;
      };

      $scope.sectionExists = function () {
        return $scope.models.form && $scope.models.form.sections && $scope.models.form.sections.length > 0;
      };

      $scope.editForm = function (form) {
        $scope.models.editing = {
          element: form
        };
      };

      $scope.editSection = function (section) {
        $scope.models.editing = {
          element: section
        };
      };

      $scope.editGroup = function (group) {
        $scope.models.editing = {
          element: group,
          availableFieldGroups: $scope.getAvailableFieldGroups()
        };
      };

      $scope.editMediaAccordionElement = function (element) {
        $scope.models.editing = {
          element: element
        };
      };

      $scope.editField = function (field, row, fieldGroup) {
        $scope.models.editing = {
          element: field,
          engineVersion: $scope.models.form.engineVersion,
          containingFieldGroup: fieldGroup,
          availableFieldGroups: $scope.getAvailableFieldGroups(),
          possibleWidthValues: []
        };
        for (var i = 1, l = $scope.maxWidthForItemInRow(field, row); i <= l; i++) {
          $scope.models.editing.possibleWidthValues.push(i);
        }
      };

      $scope.editFieldInMediaAccordionElement = function (field, group) {
        $scope.models.editing = {
          element: field,
          containingFieldGroup: group,
          availableFieldGroups: $scope.getAvailableFieldGroups(),
          possibleWidthValues: []
        };
        // only valid width for fields in media accordion elements is 12
        $scope.models.editing.possibleWidthValues = [12];
      };

      $scope.maxWidthForItemInRow = function (item, row) {
        return 12 - ($scope.getRowSize(row) - parseInt(item.width, 10));
      };

      $scope.removeSection = function (section) {
        if (confirm('Abschnitt wirklich entfernen?')) {
          var index = $scope.models.form.sections.indexOf(section);
          $scope.models.form.sections.splice(index, 1);
        }
      };

      $scope.moveSectionUp = function (section) {
        var index = $scope.models.form.sections.indexOf(section);
        if (index === 0) {
          return;
        }
        var element = $scope.models.form.sections[index];
        $scope.models.form.sections[index] = $scope.models.form.sections[index - 1];
        $scope.models.form.sections[index - 1] = element;
      };

      $scope.moveSectionDown = function (section) {
        var index = $scope.models.form.sections.indexOf(section);
        if (index === $scope.models.form.sections.length - 1) {
          return;
        }
        var element = $scope.models.form.sections[index];
        $scope.models.form.sections[index] = $scope.models.form.sections[index + 1];
        $scope.models.form.sections[index + 1] = element;
      };

      $scope.removeGroup = function (section, group) {
        if (confirm('Feldgruppe wirklich entfernen?')) {
          var index = section.fieldGroups.indexOf(group);
          section.fieldGroups.splice(index, 1);
        }
      };

      $scope.moveGroupUp = function (section, group) {
        var index = section.fieldGroups.indexOf(group);
        if (index === 0) {
          return;
        }
        var element = section.fieldGroups[index];
        section.fieldGroups[index] = section.fieldGroups[index - 1];
        section.fieldGroups[index - 1] = element;
      };

      $scope.moveGroupDown = function (section, group) {
        var index = section.fieldGroups.indexOf(group);
        if (index === section.fieldGroups.length - 1) {
          return;
        }
        var element = section.fieldGroups[index];
        section.fieldGroups[index] = section.fieldGroups[index + 1];
        section.fieldGroups[index + 1] = element;
      };

      $scope.removeRow = function (group, row) {
        if (confirm('Zeile wirklich entfernen?')) {
          var index = group.rows.indexOf(row);
          group.rows.splice(index, 1);
        }
      };

      $scope.removeMediaAccordionElement = function (group, element) {
        if (confirm('Medien-Akkordeonelement wirklich entfernen?')) {
          var index = group.elements.indexOf(element);
          group.elements.splice(index, 1);
        }
      };

      $scope.moveRowUp = function (group, row) {
        var index = group.rows.indexOf(row);
        if (index === 0) {
          return;
        }
        var element = group.rows[index];
        group.rows[index] = group.rows[index - 1];
        group.rows[index - 1] = element;
      };

      $scope.moveMediaAccordionElementUp = function (group, element) {
        var index = group.elements.indexOf(element);
        if (index === 0) {
          return;
        }
        var before = group.elements[index];
        group.elements[index] = group.elements[index - 1];
        group.elements[index - 1] = before;
      };

      $scope.moveRowDown = function (group, row) {
        var index = group.rows.indexOf(row);
        if (index === group.rows.length - 1) {
          return;
        }
        var element = group.rows[index];
        group.rows[index] = group.rows[index + 1];
        group.rows[index + 1] = element;
      };

      $scope.moveMediaAccordionElementDown = function (group, element) {
        var index = group.elements.indexOf(element);
        if (index === group.elements.length - 1) {
          return;
        }
        var before = group.elements[index];
        group.elements[index] = group.elements[index + 1];
        group.elements[index + 1] = before;
      };

      $scope.removeField = function (row, item) {
        if (confirm('Feld wirklich entfernen?')) {
          var index = row.fields.indexOf(item);
          row.fields.splice(index, 1);

          $scope.clearEmptyRows();
        }
      };

      $scope.moveFieldLeft = function (row, item) {
        var index = row.fields.indexOf(item);
        if (index === 0) {
          return;
        }
        var element = row.fields[index];
        row.fields[index] = row.fields[index - 1];
        row.fields[index - 1] = element;
      };

      $scope.moveFieldRight = function (row, item) {
        var index = row.fields.indexOf(item);
        if (index === row.fields.length - 1) {
          return;
        }
        var element = row.fields[index];
        row.fields[index] = row.fields[index + 1];
        row.fields[index + 1] = element;
      };

      $scope.deselectField = function () {
        $scope.models.selected = null;
      };
      $scope.addFieldWidth = function (row, item) {
        var index = row.fields.indexOf(item);

        var element = row.fields[index];
        element.width = parseInt(element.width, 10) + 1;
        row.fields[index] = element;
      };
      $scope.subtractFieldWidth = function (row, item) {
        var index = row.fields.indexOf(item);

        var element = row.fields[index];
        element.width = parseInt(element.width, 10) - 1;
        row.fields[index] = element;
      };

      $scope.getRowSize = function (row) {
        var sizeOfRow = 0;
        angular.forEach(row.fields, function (field) {
          sizeOfRow += parseInt(field.width, 10);
        });
        return sizeOfRow;
      };

      var checkGroupFieldDropRules = function (allowed, item, group) {
        var isGroupMultiple = !group.multiple || group.multiple.toString() === 'false';
        var isItemDisallowedInMultipleGroups = mappings.elements[item.type.toLowerCase()].disallowInMultipleFieldGroups;

        allowed = allowed && (group.layout !== 'TABLE' || item.type !== 'H1');
        allowed = allowed && (group.layout !== 'TABLE' || item.type !== 'H2');
        allowed = allowed && (group.layout !== 'TABLE' || item.type !== 'TEXT');
        allowed = allowed && (group.layout !== 'TABLE' || item.type !== 'PLACEHOLDER');
        allowed = allowed && (isGroupMultiple || !isItemDisallowedInMultipleGroups);
        return allowed;
      };

      $scope.isFieldDropAllowed = function (item, row, group) {
        // filter sections, groups and rows
        if (item.fieldGroups || item.rows || item.fields || item.elements) {
          return true;
        }

        var sizeOfRow = $scope.getRowSize(row);
        var totalSize = $scope.isItemInRow(item, row) ? sizeOfRow - parseInt(item.width, 10) : sizeOfRow;
        var allowed = totalSize < 12;
        var isItemFixedWidth = mappings.elements[item.type.toLowerCase()].fixedWidth;

        allowed = checkGroupFieldDropRules(allowed, item, group);
        allowed = allowed && !(isItemFixedWidth && totalSize + parseInt(item.width, 10) > 12);

        return allowed;
      };

      $scope.isFieldDropInGroupAllowed = function (item, group) {
        // filter sections, groups and rows
        if (item.fieldGroups || item.rows || item.fields || item.elements) {
          return true;
        }
        var allowed = true;

        allowed = allowed && (group.layout !== 'TABLE' || group.rows.length === 0);
        allowed = checkGroupFieldDropRules(allowed, item, group);

        return allowed;
      };

      $scope.isFieldDropAllowedInMediaAccordionElement = function (item, element, group) {
        // filter sections, groups and rows
        if (item.fieldGroups || item.rows || item.fields || item.elements) {
          return true;
        }
        if (mappings.elements[item.type.toLowerCase()].allowedInMediaAccordionElement) {
          return true;
        }
        return false;
      };

      $scope.isItemInRow = function (item, row) {
        return row.fields.some(function (field) {
          return field.id === item.id;
        });
      };

      $scope.dropField = function (event, index, item, row) {
        $scope.ensureItemId(item);
        var sizeOfRow = $scope.getRowSize(row);
        var totalSize = $scope.isItemInRow(item, row) ? sizeOfRow : sizeOfRow + parseInt(item.width, 10);

        if (sizeOfRow < 12 && totalSize > 12) {
          item.width = 12 - sizeOfRow;
        } else if (totalSize > 12) {
          return false;
        }

        if ($scope.models.selected && $scope.models.selected.id === item.id) {
          $scope.models.selected = item;
        }

        return item;
      };

      $scope.dropFieldInMediaAccordionElement = function (event, index, item, element) {
        $scope.ensureItemId(item);
        if ($scope.models.selected && $scope.models.selected.id === item.id) {
          $scope.models.selected = item;
        }
        return item;
      };

      $scope.ensureItemId = function (item) {
        if (
          !item.id &&
          elementHelper.getType(item) !== 'row' &&
          elementHelper.getType(item) !== 'media_accordion_element'
        ) {
          item.id = $scope.makeId();
        }
      };

      $scope.clearEmptyRows = function () {
        angular.forEach($scope.models.form.sections, function (section) {
          angular.forEach(section.fieldGroups, function (group) {
            var rowsToRemove = [];
            angular.forEach(group.rows, function (row) {
              if (row.fields.length === 0) {
                rowsToRemove.push(row);
              }
            });
            angular.forEach(rowsToRemove, function (row) {
              var indexOfRow = group.rows.indexOf(row);
              group.rows.splice(indexOfRow, 1);
            });
          });
        });
      };

      $scope.getItemWithId = function (id) {
        var item;
        angular.forEach($scope.models.form.sections, function (section) {
          if (section.id === id) {
            item = section;
            return false;
          }

          angular.forEach(section.fieldGroups, function (group) {
            if (group.id === id) {
              item = group;
              return false;
            }

            angular.forEach(group.rows, function (row) {
              if (row.id === id) {
                item = row;
                return false;
              }

              angular.forEach(row.fields, function (field) {
                if (field.id === id) {
                  item = field;
                  return false;
                }
              });
            });
          });
        });

        return item;
      };

      $scope.dropFieldInGroup = function (event, index, item) {
        $scope.ensureItemId(item);
        if (item.type !== undefined) {
          return {
            fields: [item]
          };
        }

        return item;
      };

      $scope.dropGroup = function (item) {
        $scope.ensureItemId(item);
        return item;
      };

      $scope.getDisplayLabelOrPlaceholder = function (field) {
        var retVal = field.placeholder;
        if (field.value) {
          angular.forEach(field.possibleValues, function (value) {
            if (value.value === field.value) {
              retVal = value.label;
            }
          });
        }
        return retVal;
      };

      $scope.getAllNotSelectedPossibleValues = function (field) {
        if (!field.value) {
          return field.possibleValues;
        }

        var possibleValues = [];
        angular.forEach(field.possibleValues, function (value) {
          if (field.value.indexOf(value.value) === -1) {
            possibleValues.push(value);
          }
        });
        return possibleValues;
      };

      $scope.getLabelForSelectedValue = function (selectedValue, field) {
        var label = '';
        angular.forEach(field.possibleValues, function (value) {
          if (value.value === selectedValue) {
            label = value.label;
          }
        });
        return label;
      };

      $scope.saveForm = function () {
        formHandler.saveForm($scope);
      };

      $scope.saveFormAndQuit = function () {
        formHandler.saveFormAndQuit($scope);
      };

      $scope.loadFieldGroups = function () {
        if (!$scope.isLocal && !$scope.isWeb) {
          fieldGroupService.getOwnFieldGroups().then(function (fieldGroups) {
            $scope.models.ownFieldGroups = fieldGroups;
          });
        }
        fieldGroupService.getFimFieldGroups().then(function (fieldGroups) {
          $scope.models.fimFieldGroups = fieldGroups;
        });
      };

      $scope.saveFieldGroup = function (fieldGroup) {
        if (!confirm('Wollen sie die Feldgruppe "' + fieldGroup.title + '" wirklich speichern?')) {
          return;
        }
        fieldGroupService.createFieldGroup(fieldGroup).then(
          function () {
            $scope.loadFieldGroups();
            alert('Feldgruppe "' + fieldGroup.title + '" wurde erfolgreich gespeichert!');
          },
          function (error) {
            if (error.status === 409) {
              // 409 == Conflict -> Group already exists, ask user if he wants to update it
              if (
                confirm(
                  'Eine Feldgruppe mit der ID "' +
                    fieldGroup.id +
                    '" existiert bereits. ' +
                    'Soll sie überschrieben werden?'
                )
              ) {
                $scope.updateFieldGroup(fieldGroup);
              }
            } else {
              alert(
                'Beim Speichern der Feldgruppe ist ein Fehler aufgetreten!' +
                  (error && error.data && error.data.message ? '\n\n' + error.data.message : '')
              );
            }
          }
        );
      };

      $scope.updateFieldGroup = function (fieldGroup) {
        fieldGroupService.updateFieldGroup(fieldGroup).then(
          function () {
            $scope.loadFieldGroups();
            alert('Feldgruppe "' + fieldGroup.title + '" wurde erfolgreich aktualisiert!');
          },
          function (error) {
            alert('Beim Aktualisieren der Feldgruppe ist ein Fehler aufgetreten!');
            console.error(error);
          }
        );
      };

      $scope.removeSavedGroup = function (fieldGroup) {
        if (confirm('Gespeicherte Feldgruppe "' + fieldGroup.title + '" wirklich löschen?')) {
          fieldGroupService.removeFieldGroup(fieldGroup).then(
            function () {
              $scope.loadFieldGroups();
              alert('Feldgruppe "' + fieldGroup.title + '" wurde erfolgreich gelöscht!');
            },
            function (error) {
              alert('Beim Löschen der Feldgruppe ist ein Fehler aufgetreten!');
              console.error(error);
            }
          );
        }
      };

      $scope.formChangedGuardian = function () {
        if (!angular.equals($scope.models.form, $scope.models.formOriginal)) {
          return 'Die Änderungen am Formular gehen verloren.';
        }
      };

      $scope.duplicateSection = function (section) {
        var index = $scope.models.form.sections.indexOf(section);
        if (index === -1) {
          return;
        }
        let sectionCopy = angular.copy(section);
        sectionCopy.fieldGroups.forEach((fieldGroup) => {
          fieldGroup.id = $scope.makeId();
          fieldGroup.rows.forEach((row) => {
            row.fields.forEach((field) => (field.id = $scope.makeId()));
          });
        });
        $scope.models.form.sections.splice(index + 1, 0, sectionCopy);
      };

      $scope.duplicateFieldGroup = function (section, fieldGroup) {
        var index = section.fieldGroups.indexOf(fieldGroup);
        if (index === -1) {
          return;
        }
        let fieldGroupCopy = angular.copy(fieldGroup);
        fieldGroupCopy.id = $scope.makeId();
        section.fieldGroups.splice(index + 1, 0, fieldGroupCopy);
      };

      $scope.duplicateRow = function (fieldGroup, row) {
        var index = fieldGroup.rows.indexOf(row);
        if (index === -1) {
          return;
        }
        let rowCopy = angular.copy(row);
        rowCopy.fields.forEach((field) => (field.id = $scope.makeId()));
        fieldGroup.rows.splice(index + 1, 0, rowCopy);
      };

      $scope.duplicateMediaAccordionElement = function (fieldGroup, element) {
        var index = fieldGroup.elements.indexOf(element);
        if (index === -1) {
          return;
        }
        let elementCopy = angular.copy(element);
        elementCopy.fields.forEach((field) => (field.id = $scope.makeId()));
        fieldGroup.elements.splice(index + 1, 0, elementCopy);
      };

      $scope.getAvailableFieldGroups = function () {
        var fieldGroups = [];
        angular.forEach($scope.models.form.sections, function (section) {
          fieldGroups = fieldGroups.concat(section.fieldGroups);
        });
        return fieldGroups;
      };

      $scope.duplicateField = function (fieldGroup, row, field) {
        var index;
        let fieldCopy = angular.copy(field);
        fieldCopy.id = $scope.makeId();
        if (12 - $scope.getRowSize(row) >= parseInt(field.width, 10)) {
          // Duplicate fits in current row
          index = row.fields.indexOf(field);
          if (index === -1) {
            return;
          }
          row.fields.splice(index + 1, 0, fieldCopy);
        } else {
          // Duplicate has to go into new row
          index = fieldGroup.rows.indexOf(row);
          if (index === -1) {
            return;
          }
          fieldGroup.rows.splice(index + 1, 0, {
            fields: [fieldCopy]
          });
          $scope.models.selected = fieldGroup.rows[index + 1].fields[0];
        }
      };

      $scope.duplicateFieldInMediaAccordionElement = function (element, field) {
        var index;
        let fieldCopy = angular.copy(field);
        fieldCopy.id = $scope.makeId();
        index = element.fields.indexOf(field);
        element.fields.splice(index + 1, 0, fieldCopy);
      };

      $scope.closeContextMenu = function () {
        $scope.$broadcast('context-menu/close');
      };

      $scope.makeId = function () {
        return (Math.random().toString(16) + '00000000').substr(2, 8);
      };

      $scope.newFormFile = function () {
        if (!angular.equals($scope.models.form, $scope.models.formOriginal)) {
          if (confirm('Wollen Sie Ihre Änderungen wirklich verwerfen?')) {
            formHandler.resetForm($scope);
          }
          return;
        }

        formHandler.resetForm($scope);
      };

      $scope.loadFormFile = function (event) {
        const loadFile = () => {
          const reader = new FileReader();

          reader.onload = function (event: any) {
            let jsonObj;
            try {
              jsonObj = JSON.parse(event.target.result);

              const keys = Object.keys(jsonObj);
              if (!keys.some((key) => key === 'sections')) {
                alert(
                  'Die von Ihnen ausgewählte Datei ist nicht valide. Bitte wählen Sie eine valide Formular-JSON-Datei aus.'
                );
                return;
              }

              $scope.models.form = angular.copy(jsonObj);
              $scope.models.formOriginal = angular.copy(jsonObj);
              $scope.$apply();
            } catch (error) {
              alert('Die von Ihnen ausgewählte Datei konnte nicht geladen werden.');
            }
          };

          reader.onerror = function () {
            alert('Die von Ihnen ausgewählte Datei konnte nicht geladen werden.');
          };

          reader.readAsText(event.target.files[0]);
        };

        if (!angular.equals($scope.models.form, $scope.models.formOriginal)) {
          if (confirm('Wollen Sie Ihre Änderungen wirklich verwerfen?')) {
            loadFile();
          }
          return;
        }

        loadFile();
      };

      $scope.saveFormFile = function () {
        if (!formHandler.isFormValid($scope)) {
          return false;
        }
        let filename = prompt('Bitte geben Sie einen Dateinamen ein.', `${new Date().getTime()}_formular`);
        if (filename.substring(filename.length - 5, filename.length) === '.json') {
          filename = filename.substring(0, filename.length - 5);
        }
        const anchor = document.createElement('a');
        const file = new Blob([angular.toJson($scope.models.form, true)], { type: 'application/json' });
        anchor.href = URL.createObjectURL(file);
        anchor.download = `${filename}.json`;
        anchor.click();
        $scope.models.formOriginal = angular.copy($scope.models.form);
      };

      $scope.init();
    }
  ])
  .filter('secondsToDateTime', function () {
    return function (seconds) {
      if (typeof seconds !== 'number') {
        return;
      }
      var d = new Date(0, 0, 0, 0, 0, 0, 0);

      d.setSeconds(seconds);
      return d;
    };
  })
  .filter('milliSecondsToTime', function () {
    return function (millis) {
      var d = new Date(millis);
      return '' + d.getHours() + ':' + d.getMinutes();
    };
  });
